export default "__VITE_ASSET__Ctr865lo__"